import axios from "axios";

export const fetchChallengeMappings = async (
  challengeUid: string,
  userUid: string,
  sessionUid: string
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/challenges-maping`,
      {
        params: { challenge_uid: challengeUid },
        headers: {
          accept: "application/json",
          "user-uid": userUid,
        },withCredentials: true,
      }
    );

    return response.data; // return raw API response
  } catch (error) {
    console.error("Mapping Fetch Error:", error);
    throw error; // let caller handle error
  }
};